export const aboutData = {
  title: "Who I am",
  description1:
    "I'm Ayaan, a skilled Flutter and mobile app developer with 5 years of programming and 2.5+ years of experience in Flutter.",
  description2:
    "I specialize in delivering top-quality Flutter, Android, and iOS design and development services. My expertise focuses on crafting user-friendly, high-quality, and responsive applications. With my proficiency in Flutter and UI design, I am best suited to transform your vision into reality. My commitment is to ensure your satisfaction by providing top-quality applications within the set timeline.",
  image: 3,
};
